$(document).ready(function () {
  const header = $('.header'),
    dealerHeader = $('.dealer-header');
  scrollClass = 'header_scrolled';
  const offset = dealerHeader.outerHeight();

  header.css('top', offset + 'px');

  const checkScroll = () => {
    if ($(window).width() > 768) {
      header.css({ top: Math.max(0, 70 - $(document).scrollTop()) });
    }
    else {
      header.css({ top: 0 });
    }
    if ($(window).scrollTop() > header.height()) {
      if (dealerHeader.hasClass(scrollClass))
        return;

      dealerHeader.addClass(scrollClass);
    }
    else {
      header.css('top', offset + 'px');

      dealerHeader.removeClass(scrollClass)
    }
  };

  checkScroll();
  $(window).on('scroll', checkScroll);
  $(window).on('resize', checkScroll);
});
